export default "<p class='confirmationText'>\n\n    <js-templateNonce></js-templateNonce>\n    {{ print(_.xssSoftEscape(text)) }}\n</p>";